








































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import Delete from 'vue-material-design-icons/DeleteCircle.vue'

import SearchInput from '@/components/SearchInput.vue'
import { ITenant } from '@/types/types'

@Component({
  components: { SearchInput, ChevronDown, ChevronUp, Delete },
})
export default class CardSelectTenant extends Vue {
  @Prop({ default: {} })
  currentTenant: ITenant

  tenant: any = {}
  loading: boolean = false
  isOpen: boolean = true

  get label() {
    return this.tenant.tenantName
      ? `Selecionar conta "${this.tenant.tenantName}"`
      : 'Selecione um usuário da conta desejada'
  }

  get hasTenant(): boolean {
    return !!this.currentTenant.tenantName
  }

  setLoading(value: boolean) {
    this.loading = value
  }

  onSelected(item: any) {
    this.tenant = item || {}
  }

  @Emit('selected')
  async emitSelectedTenant() {
    return this.tenant
  }

  @Emit('clean')
  async removeUserFromTenant() {
    this.loading = true
    this.tenant = {}
    this.loading = false
  }
}
